import { render, staticRenderFns } from "./tournament.vue?vue&type=template&id=f69acc5a&scoped=true"
import script from "./tournament.vue?vue&type=script&lang=js"
export * from "./tournament.vue?vue&type=script&lang=js"
import style0 from "./tournament.vue?vue&type=style&index=0&id=f69acc5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69acc5a",
  null
  
)

export default component.exports